import $ from 'jquery'

/**
 * @module Trumbowyg
 * NOTE: JQuery dependency, do not import in main.js.
 */
const Trumbowyg = (() => {
  const init = () => {
    $('.js-trumbowyg').trumbowyg({
      svgPath: '/plugins/trumbowyg-icons.svg',
      btns: [
        ['viewHTML'],
        ['formatting'],
        ['strong', 'em', 'del'],
        ['link'],
        ['insertImage'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['unorderedList', 'orderedList'],
        ['horizontalRule'],
        ['removeformat']
      ]
    })
  
  }

  return {
    init
  }
})()

export default Trumbowyg



// WEBPACK FOOTER //
// app/javascript/scripts/components/Trumbowyg.js